import { useEffect, useRef } from 'react';
import { Icon } from '../Icon/Icon';

import './checkbox.scss';

interface CheckboxProps {
    name: string;
    label: string;
    labelIcon?: string | number;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    checked: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ({ name, label, labelIcon, onChange, checked, disabled = false, indeterminate = false }) => {
    const cRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (cRef.current) {
            cRef.current.indeterminate = indeterminate;
            cRef.current.checked = checked;
        }
    }, [checked, indeterminate]);

    const id = name + '-checkbox';

    return (
        <div className="form-check trafiken-checkbox">
            <input id={id} className="form-check-input" type="checkbox" name={name} onChange={onChange} disabled={disabled} ref={cRef} />
            <label htmlFor={id} className="form-check-label d-flex justify-content-between align-items-center">
                <div>{label}</div>
                {labelIcon && <Icon symbol={labelIcon} className="trafiken-checkbox__label-icon" />}
            </label>
        </div>
    );
};

export default Checkbox;
